import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import About from "./components/About";
import Blogs from "./components/Blogs";
import Contact from "./components/Contact";
import Home from "./components/Home";
import Services from "./components/Services";
import Navbar from "./components/Navbar";
import ScrollToTop from "./components/ScrollToTop";
import NotFound from "./components/NotFound";
import LocalBusinessJsonLd from "./components/seo/LocalBusinessJsonLd";

// Import the service pages
import OilChange from "./components/servicep/OilChange";
import BrakesSuspension from "./components/servicep/BrakesSuspension";
import BatteryReplacement from "./components/servicep/BatteryReplacement";
import SmogEmissionsServices from "./components/servicep/SmogEmissionsServices";
import ElectricalDiagnostics from "./components/servicep/ElectricalDiagnostics";
import SmokeTest from "./components/servicep/SmokeTest";
import AirConditioning from "./components/servicep/AirConditioning";
import AllFactoryMaintenance from "./components/servicep/AllFactoryMaintenance";
import TireServicesAlignment from "./components/servicep/TireServiceAlignment";
import TransferCase from "./components/servicep/TransferCase";
import DiffService from "./components/servicep/DiffService";
import TransmissionFlush from "./components/servicep/TransmissionFlush";
import ABSSystem from "./components/servicep/ABS-System";
import TimingBelt from "./components/servicep/TimingBelt";
import TuneUPS from "./components/servicep/TuneUps";
import ParasiticDraw from "./components/servicep/ParasiticDraw";
import AltReplacement from "./components/servicep/AlternatorReplacement";
import RadReplacement from "./components/servicep/RadiatorReplacement";
import WaterP from "./components/servicep/WaterPump";
import PowerS from "./components/servicep/PowerSteer";
import EngineFlush from "./components/servicep/EngineFlush";
import FuelInjection from "./components/servicep/FuelInjection";
import BrakeFlush from "./components/servicep/BrakeFlush";
import CoolantFlush from "./components/servicep/CoolantFlush";
import AutoRepair from "./components/servicep/AutoRepair";
import CheckEngineLight from "./components/servicep/CheckEngineLight";
import TransmissionRepair from "./components/servicep/TransmissionRepair";
import EuropeanAutoRepair from "./components/servicep/EuropeanAutoRepair";
import LandRoverRepair from "./components/servicep/LandRoverRepair";
import JaguarRepair from "./components/servicep/JaguarRepair";

// Import the Footer component
import Footer from "./components/Footer";
import MobileCTABar from "./components/ui/MobileCTABar";

function App() {
  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <ScrollToTop />
      <LocalBusinessJsonLd />

      {/* Wrapper: no global background image here.
          Each page (Home especially) controls its own hero/background for best quality. */}
      <div className="relative flex min-h-screen w-full flex-col bg-white">
        <a
          href="#main-content"
          className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-[100] focus:rounded-lg focus:bg-teal-600 focus:px-4 focus:py-2 focus:text-sm focus:font-semibold focus:text-white"
        >
          Skip to main content
        </a>
        <div className="relative z-10 flex-grow min-h-screen flex flex-col pb-16 md:pb-0">
          <Navbar />

          <div id="main-content" tabIndex={-1} className="min-w-0 flex-grow w-full outline-none">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/blogs" element={<Blogs />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/about" element={<About />} />

              <Route path="/auto-repair" element={<AutoRepair />} />
              <Route path="/check-engine-light" element={<CheckEngineLight />} />
              <Route path="/transmission-repair" element={<TransmissionRepair />} />
              <Route path="/european-auto-repair" element={<EuropeanAutoRepair />} />
              <Route path="/land-rover-repair" element={<LandRoverRepair />} />
              <Route path="/jaguar-repair" element={<JaguarRepair />} />

              {/* Service Pages */}
              <Route path="/services/tire-alignment" element={<TireServicesAlignment />} />
              <Route path="/services/oil-change" element={<OilChange />} />
              <Route path="/services/brake-suspension" element={<BrakesSuspension />} />
              <Route path="/services/battery-replacement" element={<BatteryReplacement />} />
              <Route path="/services/smog-emissions-services" element={<SmogEmissionsServices />} />
              <Route path="/services/electrical-diagnostics" element={<ElectricalDiagnostics />} />
              <Route path="/services/smoke-test" element={<SmokeTest />} />
              <Route path="/services/air-conditioning" element={<AirConditioning />} />
              <Route path="/services/all-factory" element={<AllFactoryMaintenance />} />
              <Route path="/services/transfer-case" element={<TransferCase />} />
              <Route path="/services/diff-service" element={<DiffService />} />
              <Route path="/services/transmission-flush" element={<TransmissionFlush />} />
              <Route path="/services/abs-system" element={<ABSSystem />} />
              <Route path="/services/timing-belt-replacement" element={<TimingBelt />} />
              <Route path="/services/tune-ups" element={<TuneUPS />} />
              <Route path="/services/parasitic-draw" element={<ParasiticDraw />} />
              <Route path="/services/alternator-replacement" element={<AltReplacement />} />
              <Route path="/services/radiator-replacement" element={<RadReplacement />} />
              <Route path="/services/water-pump" element={<WaterP />} />
              <Route path="/services/power-steering-flush" element={<PowerS />} />
              <Route path="/services/engine-flush" element={<EngineFlush />} />
              <Route path="/services/fuel-injection" element={<FuelInjection />} />
              <Route path="/services/brake-flush" element={<BrakeFlush />} />
              <Route path="/services/coolant-flush" element={<CoolantFlush />} />

              {/* Catch-all: client-side "not found" view. See NotFound.js for the
                  HTTP-status caveat under the current Netlify SPA rewrite. */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </div>

          <Footer />
        </div>

        <MobileCTABar />
      </div>
    </Router>
  );
}

export default App;
